
// // Function to get the auth token (You may need to create this function based on your token logic)
// export const getAuthToken = async (clientId, clientSecret) => {
//     // Replace this with your token fetching logic
//     const tokenResponse = await axios.post('https://coremarketplace.paypro.com.pk/api/paypro/auth', {
//         clientid: clientId,
//         clientsecret: clientSecret,
//     });
//     return tokenResponse.data.token;
// };
//
// export const payproCreateOrder = async (clientId, clientSecret, payload) => {
//     try {
//         // Get the token
//         const token = await getAuthToken(clientId, clientSecret);
//
//         // Set the headers
//         const headers = {
//             'token': token,
//             'Content-Type': 'application/json',
//         };
//
//         // Determine the API URL based on the environment
//         const url = 'https://coremarketplace.paypro.com.pk/qrapi/api/paypro/create-order';
//
//         // Make the POST request with Axios
//         const response = await axios.post(url, payload, { headers });
//
//         // Handle the response data
//         console.log(response.data);
//
//         // Return or process the response body as needed
//         return response.data;
//
//     } catch (error) {
//         // Handle error
//         console.error('Error creating order:', error);
//     }
// };

export const  formatDate = (date) => {
    const day = String(date?.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

export const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export const isValidPakistaniNumber = (phoneNumber) => {
    // Regex to match Pakistani numbers in both formats: local (03xx) or international (+92/0092)
    const pakistaniPhoneRegex = /^(?:\+92|0092|03)[0-9]{9}$/;
    return pakistaniPhoneRegex.test(phoneNumber);
};

export const getNumericTimestamp = () => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    return Number(
        `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`
    ).toString();
};

